import {
  SET_TASKS,
  FIND_IFLOW_TASKS_BY_FILTERS,
  UPDATE_READFLAG,
  SET_UPDATE_READFLAG,
} from "./actionTypes";

const initialState = {
  tasks: [],
  isLoadingTasks: false,
  isLoadingUpdateReadFlag: false,
  message: [],
};

export function tasksReducer(state = initialState, action) {
  switch (action.type) {
    case FIND_IFLOW_TASKS_BY_FILTERS:
      return { ...state, isLoadingTasks: true };
    case SET_TASKS:
      return { ...state, tasks: action.data, isLoadingTasks: false };
    case UPDATE_READFLAG:
      return { ...state, isLoadingUpdateReadFlag: true };
    case SET_UPDATE_READFLAG:
      return { ...state, message: action.data, isLoadingUpdateReadFlag: false };
    default:
      return state;
  }
}
